import styled from 'styled-components'

export const ColorIndicator = styled.div<{ color: string }>`
  border: 1px solid ${props => props.theme.colors.color2d3139};
  background: ${({ color }) => color};
  width: 12px;
  height: 12px;
  border-radius: 50%;
`

export const Description = styled.span`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;

  color: ${props => props.theme.colors.color2d3139};
`
